/* =========================================================================
   SAMSARA — SECTION-PAGE-GUIDE.JS
   Pillar page interactivity: scrollspy TOC + recommender + mobile TOC toggle.
   Myth accordion = native <details>, no JS needed.
   ========================================================================= */

(function () {
  'use strict';

  const root = document.querySelector('[data-page-guide]');
  if (!root) return;

  /* -------- Scrollspy: highlight active TOC link based on visible section ---- */
  (function initScrollspy() {
    const tocLinks = root.querySelectorAll('[data-toc-link]');
    const sections = Array.from(tocLinks).map(function (link) {
      const id = link.getAttribute('href').replace(/^#/, '');
      return document.getElementById(id);
    }).filter(Boolean);

    if (!sections.length || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          tocLinks.forEach(function (link) {
            const active = link.getAttribute('href') === '#' + id;
            link.classList.toggle('is-active', active);
          });
        }
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    sections.forEach(function (s) { observer.observe(s); });
  })();

  /* -------- Mobile TOC toggle (FAB) ---------------------------------------- */
  (function initTocToggle() {
    const toc = root.querySelector('[data-page-guide-toc]');
    const toggle = root.querySelector('[data-page-guide-toc-toggle]');
    const close = root.querySelector('[data-page-guide-toc-close]');
    if (!toc || !toggle) return;

    toggle.addEventListener('click', function () {
      toc.classList.add('is-open');
      document.body.classList.add('is-scroll-locked');
    });

    if (close) {
      close.addEventListener('click', function () {
        toc.classList.remove('is-open');
        document.body.classList.remove('is-scroll-locked');
      });
    }

    toc.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        toc.classList.remove('is-open');
        document.body.classList.remove('is-scroll-locked');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toc.classList.contains('is-open')) {
        toc.classList.remove('is-open');
        document.body.classList.remove('is-scroll-locked');
      }
    });
  })();

  /* -------- Recommender: produce suggestion based on flavor + method ------- */
  (function initRecommender() {
    const form = root.querySelector('[data-page-guide-recommender]');
    if (!form) return;

    const flavorSelect = form.querySelector('[data-rec-flavor]');
    const methodSelect = form.querySelector('[data-rec-method]');
    const submitBtn = form.querySelector('[data-rec-submit]');
    const result = form.querySelector('[data-rec-result]');
    if (!flavorSelect || !methodSelect || !submitBtn || !result) return;

    const LIBRARY = {
      ciocolata: {
        espresso: 'Pentru un espresso clasic, alege un blend special — <a href="/products/espresso-blend-ethiopia-brazil">Espresso Blend Ethiopia + Brazil</a> sau o cafea din <strong>Brazilia</strong> cu note de cacao și nuci.',
        filtru: 'Pentru filtru cu profil reconfortant, o origine din <strong>Brazilia</strong> sau <strong>Guatemala</strong> e excelentă — corp plin, dulceață caramelizată.',
        french_press: 'French Press cere corp plin. Brazilia naturală sau un blend cu Brazilia ca bază scot maximum din metodă.',
        moka: 'Moka pot-ul amplifică ciocolatiul. Columbia sau Brazilia, măcinare medie-fină.'
      },
      fructat: {
        espresso: 'Pentru espresso vibrant, încearcă un microlot precum <a href="/collections/cafea-de-specialitate">Columbia anaerobic honey</a>. Pulled fast, păstrează esterii.',
        filtru: 'O cafea africană — <strong>Kenya</strong> sau <strong>Etiopia natural</strong> — la V60 sau Chemex îți va oferi o ceașcă curată cu aciditate complexă.',
        french_press: 'Kenya washed sau Etiopia natural, fără stir, imersie statică 4 min. Aciditate complexă cu sediment minim.',
        moka: 'O cafea naturală din Brazilia poate oferi note de fructe coapte. Moka nu e prima alegere pentru fructat clar.'
      },
      floral: {
        espresso: 'Caută <strong>Etiopia Yirgacheffe</strong> sau Geisha. Pulled fast la 93°C, ratio 1:1.8 pentru a păstra notele de iasomie și bergamotă.',
        filtru: 'Profilul floral strălucește la filtru. Etiopia washed, V60, apă 94°C, măcinare medie.',
        french_press: 'French Press tinde să atenueze florile. Folosește cafea proaspătă (<14 zile), ratio 1:18, apă la 92°C.',
        moka: 'Moka pot e prea agresiv pentru florile delicate. Recomandare: schimbă metoda la pour-over sau AeroPress.'
      },
      echilibrat: {
        espresso: 'Un <a href="/products/espresso-blend-ethiopia-brazil">Espresso Blend</a> sau o cafea din <strong>Columbia</strong> sau <strong>Costa Rica</strong>. Ratio 1:2 standard.',
        filtru: 'Cafele din <strong>Columbia</strong>, <strong>Costa Rica</strong> sau <strong>El Salvador</strong> sunt renumite pentru echilibru. V60 cu profil balanced.',
        french_press: 'Columbia washed sau Guatemala. Setting clasic, imersie 4 min, decantează imediat.',
        moka: 'Columbia sau un blend echilibrat. Robust dar nu agresiv.'
      }
    };

    submitBtn.addEventListener('click', function () {
      const flavor = flavorSelect.value;
      const method = methodSelect.value;
      const message = (LIBRARY[flavor] && LIBRARY[flavor][method]) || 'Sugestie indisponibilă pentru combinația aleasă.';
      result.innerHTML = '<p>' + message + '</p>';
      result.hidden = false;
    });
  })();

})();
